const AuthInterceptor = (req, next) => {
  const modifiedRequest = req.clone({
    setHeaders: {
      'Authorization': 'Basic ' + btoa('softengine:fG1n7XnvR9fUqfHnw3m9')
    }
  });
  return next(modifiedRequest);
};

/**
 * Generated bundle index. Do not edit.
 */

export { AuthInterceptor };
